<template>
  <ar-modal
    :is-open="showModal"
    class="opt-in-modal"
    width="700px"
    hide-header
    hide-footer
    :mobile="$arMediaQuery.window.maxWidth('xs')"
    @close="handleOptOut"
  >
    <div
      slot="body"
      :class="[
        'opt-in-modal-body',
        $arMediaQuery.window.maxWidth('xs') && 'u-padding-x-5',
      ]"
    >
      <img 
        :src="imagePath" 
        alt="Audience Manager 3" 
        class="opt-in-image"
      />

      <div class="opt-in-content">
        <div class="early-access-badge">

          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M10 13C9.77676 13 9.58057 12.852 9.51924 12.6374L8.97711 10.7399C8.73981 9.90938 8.09062 9.26018 7.2601 9.02289L5.36264 8.48076C5.14799 8.41943 5 8.22324 5 8C5 7.77676 5.14799 7.58057 5.36264 7.51924L7.2601 6.97711C8.09062 6.73982 8.73982 6.09062 8.97711 5.2601L9.51924 3.36264C9.58057 3.14799 9.77676 3 10 3C10.2232 3 10.4194 3.14799 10.4808 3.36264L11.0229 5.2601C11.2602 6.09062 11.9094 6.73982 12.7399 6.97711L14.6374 7.51924C14.852 7.58057 15 7.77676 15 8C15 8.22324 14.852 8.41943 14.6374 8.48076L12.7399 9.02289C11.9094 9.26018 11.2602 9.90938 11.0229 10.7399L10.4808 12.6374C10.4194 12.852 10.2232 13 10 13Z" fill="#9333EA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M4 15C3.77057 15 3.57057 14.8439 3.51493 14.6213L3.34235 13.931C3.1856 13.304 2.69604 12.8144 2.06904 12.6576L1.37873 12.4851C1.15615 12.4294 0.999998 12.2294 0.999998 12C0.999998 11.7706 1.15615 11.5706 1.37873 11.5149L2.06904 11.3424C2.69604 11.1856 3.1856 10.696 3.34235 10.069L3.51493 9.37873C3.57057 9.15615 3.77057 9 4 9C4.22943 9 4.42942 9.15615 4.48507 9.37873L4.65765 10.069C4.8144 10.696 5.30396 11.1856 5.93096 11.3424L6.62127 11.5149C6.84385 11.5706 7 11.7706 7 12C7 12.2294 6.84385 12.4294 6.62127 12.4851L5.93096 12.6576C5.30396 12.8144 4.8144 13.304 4.65765 13.931L4.48507 14.6213C4.42942 14.8439 4.22943 15 4 15Z" fill="#9333EA"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 6C4.78478 6 4.59372 5.86228 4.52566 5.65811L4.26283 4.86963C4.16329 4.57102 3.92898 4.33671 3.63037 4.23717L2.84189 3.97434C2.63771 3.90628 2.5 3.71521 2.5 3.5C2.5 3.28478 2.63771 3.09372 2.84189 3.02566L3.63037 2.76283C3.92898 2.66329 4.16329 2.42898 4.26283 2.13037L4.52566 1.34189C4.59372 1.13772 4.78478 1 5 1C5.21521 1 5.40628 1.13772 5.47434 1.34189L5.73717 2.13037C5.83671 2.42898 6.07102 2.66329 6.36963 2.76283L7.15811 3.02566C7.36229 3.09372 7.5 3.28478 7.5 3.5C7.5 3.71522 7.36229 3.90628 7.15811 3.97434L6.36963 4.23717C6.07102 4.33671 5.83671 4.57102 5.73717 4.86963L5.47434 5.65811C5.40628 5.86228 5.21521 6 5 6Z" fill="#9333EA"/>
            </svg>


          EARLY ACCESS
        </div>
        <ar-text
          class="opt-in-modal-title"
          text="Try the new Audience Manager"
          weight="bold"
          align="center"
          size="md"
        />
        
        <ar-text
          class="opt-in-modal-message"
          size="xs"
          text="Experience a faster, smarter way to manage your audience — before it's officially released."
          multiple-lines
          line-height="25px"
          align="center"
        />
        
        <!-- <a href='#' style='color: #6366F1;'>Learn more</a> -->
        <ar-text
          class="opt-in-modal-message"
          size="xs"
          allow-html
          text="You can switch back to the classic view anytime from your Settings. "
          multiple-lines
          line-height="25px"
          align="center"
        />
      </div>

      <div class="opt-in-button-wrapper">
        <ar-simple-button
          text="Do this later"
          type="grey"
          @click="handleOptOut"
          :style="{

          }"
        />
        <ar-simple-button
          text="Join early access"
          type="purple"
          @click="handleOptIn"
          :style="{
            marginLeft: '20px',
          }"
        />
      </div>
    </div>
  </ar-modal>
</template>

<script>

import { getCookie, setCookie } from '@/utils/cookie.js';

import promoImage from '@/assets/images/audience/am3-optin-promo.png';

export default {
  name: 'OptInModal',

  data() {
    return {
      showModal: false,
      imagePath: promoImage
    };
  },

  created() {
    window.addEventListener('arModalOpen', this.handleModalOpen);
  },

  beforeDestroy() {
    window.removeEventListener('arModalOpen', this.handleModalOpen);
  },

  methods: {
    handleModalOpen({ detail: { action, payload } }) {
      if (action !== 'OPEN_OPT_IN_MODAL') return;
      this.startModalAction(payload);
    },

    respondModalAction(payload) {
      window.dispatchEvent(new CustomEvent('arModalResponse', { detail: { action: 'OPEN_OPT_IN_MODAL', payload } }));
    },

    startModalAction(payload = {}) {
      // You can accept custom image path or other options from payload
      if (payload.imagePath) {
        this.imagePath = payload.imagePath;
      }
      
      this.showModal = true;
    },

    handleOptIn() {
      // Set cookie with no expiration (permanent)
      setCookie('am3EarlyAccessOptIn', 'true', {
        path: '/',
        // No maxAge (permanent)
      });
      
      this.respondModalAction({
        optedIn: true
      });
      this.showModal = false;
      
      // Additional logic for opt-in behavior
      console.log('User opted in to early access');
    },

    handleOptOut() {
      // Set cookie with 7-day expiration
      setCookie('am3EarlyAccessOptIn', 'false', {
        path: '/',
        maxAge: 60 * 60 * 24 * 7 // 7 days
      });
      
      this.respondModalAction({
        optedIn: false
      });
      this.showModal = false;
      
      // Additional logic for opt-out behavior
      console.log('User opted out of early access');
    }
  }
};
</script>

<style lang="scss" scoped>

.ar-modal.ar-modal-body {
  border-radius: 8px;
  font-family: "Inter", sans-serif !important ;

}

.opt-in-modal {
  .opt-in-modal-body {
    padding: 24px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: hidden;
    font-family: 'Inter', sans-serif;
    
  }

  .opt-in-image {
    width: 100%;
    height: auto;
    max-height: 320px;
    object-fit: cover;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
  }

  .opt-in-content {
    padding: 24px 48px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .early-access-badge {
    display: inline-flex;
    flex-direction: row; 
    align-items: center;
    padding: 4px 12px;
    background-color: #F3F4F6;
    color: #9333EA;
    font-size: 12px;
    font-weight: bold;
    border-radius: 8px;
    margin-bottom: 20px;
    > svg {
      margin-right: .5rem;
    }
  }

  .opt-in-modal-title {
    margin-bottom: 16px;
    font-size: 24px;
  }

  .opt-in-modal-message {
    margin-bottom: 8px;
    color: #6B7280;
  }

  .opt-in-button-wrapper {
    display: flex;
    justify-content: center;
    margin: 24px 0 36px;
  }

  button {
    padding-bottom: 12px 16px;
    font-weight: 600;
    font-size: 14px;
    // line-height: Font/Line Height/Leading-5;
    letter-spacing: 0%;
    text-align: center;
    border-radius: 6px;
    >>> .text-section__inner {
      font-family: "Inter", sans-serif !important ;
    }
  }

  button:first-child {
    margin-bottom: 16px;
    border: 1px solid #D6D3D1;
    background: transparent; 
    >>> .text-section__inner {
      color: #222222;
    }
    &:hover {
      background: #FAFAF9 ;
    }
  }

  button:nth-child(2) {
    border: 1px solid #9333EA;
    background-color: #9333EA;
    color: #fff;
    &:hover {
      background-color: #7E22CE;
    }
  }


  @media (max-width: 640px) {
    .opt-in-content {
      padding: 24px 16px;
    }

    .opt-in-button-wrapper {
      flex-direction: column;
      align-items: center;
      margin: 16px 0 24px;
      

      button:first-child {
        margin-bottom: 16px;
        border: 1px solid #9333EA;
      }
      
      button {
        width: 100% !important;
        margin-left: 0 !important;
      }
    }
  }
}

</style>


<style>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');


.opt-in-modal  .ar-text section.text-section__inner ,
.opt-in-modal button:first-child .ar-text section.text-section__inner {
    color: #000;
}

.opt-in-modal button:nth-child(2) .ar-text section.text-section__inner {
  color: #fff;
}

.opt-in-modal * {
    font-family: "Inter", sans-serif !important ;
}

.opt-in-modal .ar-modal-cross-icon {
  background: #fff;
  /* transform: translateX(3.5rem) translateY(-3rem); */
  border-radius: 999px;
}

</style>
